module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-06-9fbf8152b06c8ee4619db37a05548f59.svg";